import React, { Component } from "react";
import { connect } from "react-redux";
import { signUpVerified } from '../../actions/initActions' 
import { useCookies, withCookies } from 'react-cookie';
import { SOCKET_CLIENT_URL } from "../../actions/api";
import io from 'socket.io-client';
import { getIPDetails } from "../../actions/loginActions";
import { checkUrlSlugAndSlash } from "../../utils";
import LoadingScreen from "../CommonComponents/LoadingScreen";

const VerifyEmail = (props) => {
    const [cookies, setCookie] = useCookies(['emailConfirmation']);
    // path '/' zaroori hai - warna cookie sirf /accounts/verifyemail/... pe readable rehti hai
    return <VE {...props} setCookie={() => setCookie('emailConfirmation', true, { path: '/' })} />
}

const SOCKET_CONNECTION = !window.location.href.includes('accounts/login') && checkUrlSlugAndSlash(window.location.href).hasSlug ? io(`${SOCKET_CLIENT_URL}`, {
    transports: ["websocket"],
    transport: ["websocket"],
    upgrade: true,
    reconnection: true,
    reconnectionDelay: 3000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: 2
}) : ({})

let request = false;
class VE extends Component {

    componentWillMount() {
        this.signUpVerified();
    }

    signUpVerified = async () => {
        let data = {};
        const { params, history, setCookie } = this.props;

        // verification token server pe single-use hai. `request` module flag sirf ek page load ke
        // liye hai - agar beech me page reload ho jaye to wo reset ho jata hai aur same token
        // dobara verify hone chala jata hai (jo hamesha fail karta hai). sessionStorage reload ke
        // baad bhi bacha rehta hai, isliye consume hua token yahan mark kar dete hain.
        const consumedKey = `signup_verified_${params.id}`;

        // access_token set hote hi RoutesExtends LoginBasePage se BasePage pe switch karta hai,
        // jisse ye component remount ho jata hai. Us case me kuch mat karo - verification thunk
        // already chal raha hai aur wahi redirect karega.
        if (request) return;

        if (sessionStorage.getItem(consumedKey)) {
            history(localStorage.getItem('access_token') ? "/walls/home" : "/accounts/login");
            return;
        }

        request = true;
        await getIPDetails().then((ipResponse) => {
            data = ipResponse.data;
        }).catch(ex => console.log(ex));

        const search = window.location.search ? window.location.search : (window.location.href.includes('?') ? `?${window.location.href.split('?')[1]}` : '');
        const guestId = new URLSearchParams(search).get('guestId');

        // Verify link hamesha us account ke liye hota hai jo abhi verify ho raha hai. Agar browser me
        // pehle se koi session pada hai to uska token / ownerId headers ke saath chale jaate hain aur
        // verification galat user ke context me hoti hai, isliye purana session pehle hata do.
        ['access_token', 'authToken', 'user_data', 'ownerId', 'loginOwnerId', 'isCollaborator', 'wallId', 'isOnboarding', 'plan_exceeded'].forEach(key => localStorage.removeItem(key));

        try { sessionStorage.setItem(consumedKey, '1'); } catch (ex) { console.log(ex); }

        this.props.signUpVerified({ countryCode: (data && Object.keys(data).length > 0) ? data.country : "US" }, params.id, history, setCookie, this.ON_EMIT_SOCKET_DATA, guestId)
    }

    ON_EMIT_SOCKET_DATA = (userId) => {
        SOCKET_CONNECTION.emit('updatePlan', { id: userId, plan: "" });
    }

    render() {
        return <><LoadingScreen /></>
    }
}

const mapDispatchToProps = dispatch => {
    return {
        signUpVerified: (country, token, history, setCookie, emitSocket, webSiteUser) => dispatch(signUpVerified(country, token, history, setCookie, emitSocket, webSiteUser))
    }
}
export default connect(null, mapDispatchToProps)(withCookies(VerifyEmail));